import type { CommonService } from '../../../components/common/common.service'

import { app } from '../../../app.module'

/**
 * アカウントのメモ管理ボタン
 * @class AccountMemoManagementButton
 */
class AccountMemoManagementButton {
  private snsType: string
  private memoCount: number
  private accountData: {
    accountId: string
    screenName: string
    pictureUrl: string
  }

  constructor(
    private $rootScope,
    private CommonService: CommonService
  ) {
    // メモ数が変更されるイベント
    $rootScope.$on('changeMemo', (event, changeInfo) => {
      // 対象アカウントのメモ数が変更される場合
      if (
        changeInfo.objectType === 'account' &&
        changeInfo.objectId === this.accountData.accountId &&
        changeInfo.snsType === this.snsType
      ) {
        switch (changeInfo.type) {
          case 'add':
            this.memoCount = this.memoCount + 1
            break
          case 'delete':
            this.memoCount = this.memoCount - 1
            break
        }
      }
    })
  }

  /**
   * メモ管理ボタンをクリックした際の処理
   */
  public showMemoManagement(): void {
    this.CommonService.showAccountDetailModal(this.snsType, 'memo', this.accountData.accountId)
  }
}

app.component('accountMemoManagementButton', {
  bindings: {
    snsType: '@',
    memoCount: '=',
    accountData: '<',
  },
  template: require('./memo-management-button.pug')(),
  controller: AccountMemoManagementButton,
})
